import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "../context/LangContext";

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

export default function InvitePoster({ code }) {
  const { t } = useLang();
  const [saving, setSaving] = useState(false);
  const link = code ? `${window.location.origin}/login?ref=${code}` : window.location.origin;

  const makeImage = () => new Promise((resolve) => {
    const logo = new Image();
    logo.onload = () => draw(logo);
    logo.onerror = () => draw(null);
    logo.src = "/brand_logo.jpg";
    const draw = (img) => {
    const W = 720, H = 1000;
    const c = document.createElement("canvas");
    c.width = W; c.height = H;
    const ctx = c.getContext("2d");
    const bg = ctx.createLinearGradient(0, 0, 0, H);
    bg.addColorStop(0, "#13205a"); bg.addColorStop(1, "#050816");
    ctx.fillStyle = bg; ctx.fillRect(0, 0, W, H);
    const rg = ctx.createRadialGradient(W / 2, 230, 30, W / 2, 230, 520);
    rg.addColorStop(0, "rgba(255,138,31,0.4)"); rg.addColorStop(1, "rgba(255,215,0,0)");
    ctx.fillStyle = rg; ctx.fillRect(0, 0, W, 520);
    ctx.strokeStyle = "rgba(255,215,0,0.6)"; ctx.lineWidth = 6; roundRect(ctx, 24, 24, W - 48, H - 48, 28); ctx.stroke();
    ctx.textAlign = "center";
    ctx.fillStyle = "#FFD700"; ctx.font = "bold 54px sans-serif"; ctx.fillText("BAM BAM BHOLE", W / 2, 110);
    if (img) { ctx.save(); roundRect(ctx, W / 2 - 100, 170, 200, 200, 28); ctx.clip(); ctx.drawImage(img, W / 2 - 100, 170, 200, 200); ctx.restore(); }
    ctx.fillStyle = "#FFB566"; ctx.font = "bold 44px sans-serif"; ctx.fillText(t("inviteFriends"), W / 2, 420);
    ctx.fillStyle = "#cbd5e1"; ctx.font = "26px sans-serif"; ctx.fillText(t("inviteText"), W / 2, 470);
    ctx.fillStyle = "rgba(0,0,0,0.45)"; roundRect(ctx, 100, 540, W - 200, 130, 20); ctx.fill();
    ctx.fillStyle = "#94a3b8"; ctx.font = "22px sans-serif"; ctx.fillText(t("yourCode"), W / 2, 588);
    ctx.fillStyle = "#FFD700"; ctx.font = "bold 56px monospace"; ctx.fillText(code || "----", W / 2, 648);
    ctx.fillStyle = "rgba(0,0,0,0.45)"; roundRect(ctx, 70, 720, W - 140, 110, 18); ctx.fill();
    ctx.fillStyle = "#94a3b8"; ctx.font = "22px sans-serif"; ctx.fillText("Join & play 👇", W / 2, 766);
    ctx.fillStyle = "#FFD700"; ctx.font = "bold 24px sans-serif"; ctx.fillText(link, W / 2, 802);
    ctx.fillStyle = "#64748b"; ctx.font = "20px sans-serif"; ctx.fillText("Play · Win · Withdraw in ₹", W / 2, 900);
    c.toBlob((b) => resolve(b), "image/png");
    };
  });

  const download = async () => {
    setSaving(true);
    try {
      const blob = await makeImage();
      const file = new File([blob], "bambambhole-invite.png", { type: "image/png" });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        try { await navigator.share({ files: [file], text: t("inviteText") }); return; } catch {}
      }
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = "bambambhole-invite.png"; a.click();
      URL.revokeObjectURL(url);
      toast.success(t("imageSaved"));
    } catch { toast.error("Could not create image"); }
    finally { setSaving(false); }
  };

  return (
    <button onClick={download} disabled={saving} data-testid="invite-poster-btn"
      className="flex items-center gap-2 rounded-xl border border-fuchsia-400/40 bg-fuchsia-500/10 px-4 py-3 text-sm font-bold text-fuchsia-200 hover:border-fuchsia-400/80 transition-colors">
      {saving ? <Loader2 size={16} className="animate-spin" /> : <Download size={16} />} {t("downloadPoster")}
    </button>
  );
}
